export default function UserModel () {
    return model;
}

const model = {
    firstName: {
      required: {
        message: 'This field is required.'
      }
    },
    lastName: {
      required: {
        message: 'This field is required.'
      }
    },
    title: {
      required: {
          message: 'This field is required.'
      }
    },
    direct_dial: {
      required: {
        message: 'This field is required.'
      },
      isLength: {
        options: {min: 10, max: 10},
        message: 'Must be 10 digits'
      },
      isNumeric: {
        message: 'Must be numeric'
      }
    },
    cellphoneNumber: {
      isLength: {
        options: {min: 10, max: 10},
        message: 'Must be 10 digits'
      },
      isNumeric: {
        message: 'Must be numeric'
      }
    },
    email: {
      required: {
        message: 'This field is required.'
      },
      isEmail: {
        message: 'Must be a valid email.'
      }
    },
    state: {},
    roles: {},
    activeState: {
      required: {
        message: 'This field is required.'
      }
    },
    categories: {},
    weight: {},
    defaultRole: {}
};



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/User/Create/model.js